export default __webpack_public_path__ + "static/image-13-f8154902c50eba0e329f316a7e9251f2.jpg";